import { DeleteOutlined, EditOutlined, PlusOutlined, EyeOutlined, ShareAltOutlined, LinkOutlined, FileTextOutlined } from '@ant-design/icons';
import { Button, Form, Input, message, Modal, Select, Space, Table, Tag, Upload, Checkbox, UploadFile, Dropdown, Menu } from 'antd';
import { RcFile } from 'antd/lib/upload';
import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { postService } from '../services/postService';
import { Post } from '../types/post';
import { configService } from '../services/configService';
import axios from 'axios';

const { Search } = Input;
const { Option } = Select;

const PostForm: React.FC<{
  onImagesChange: (files: File[]) => void;
  selectedFileList: UploadFile[];
  isMobile?: boolean;
}> = ({ onImagesChange, selectedFileList, isMobile = false }) => {
  const [fileList, setFileList] = useState<UploadFile[]>(selectedFileList);


  useEffect(() => {
    console.log('selectedFileList: ', selectedFileList);

    if (selectedFileList.length > 0) {
      setFileList(selectedFileList);
    }
  }, [selectedFileList]);

  const handleChange = ({ fileList: newFileList }: any) => {
    setFileList(newFileList);
    const files = newFileList.map((file: any) => file.originFileObj).filter(Boolean);
    onImagesChange(files);
  };

  return (
    <div className={isMobile ? 'mobile-form' : ''}>
      <Form.Item
        name="title"
        label="Tiêu đề"
        rules={[{ required: true, message: 'Vui lòng nhập tiêu đề' }]}
      >
        <Input placeholder="Nhập tiêu đề bài viết" maxLength={100} showCount />
      </Form.Item>

      <Form.Item
        name="description"
        label="Trích dẫn"
        rules={[{ required: true, message: 'Vui lòng nhập trích dẫn' }]}
      >
        <Input.TextArea
          placeholder="Nhập trích dẫn ngắn gọn về bài viết"
          maxLength={200}
          showCount
          rows={3}
        />
      </Form.Item>

      <Form.Item
        name="author"
        label="Tác giả"
      >
        <Input placeholder="Nhập tên tác giả" />
      </Form.Item>

      <Form.Item
        name="content"
        label="Nội dung"
        rules={[{ required: true, message: 'Vui lòng nhập nội dung' }]}
      >
        <ReactQuill
          theme="snow"
          modules={{
            toolbar: [
              [{ 'header': [1, 2, 3, false] }],
              ['bold', 'italic', 'underline', 'strike'],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              [{ 'align': [] }],
              ['link', 'image'],
              ['clean']
            ],
          }}
        />
      </Form.Item>

      <Form.Item
        name="images"
        label="Hình ảnh"
        rules={[{ required: true, message: 'Vui lòng chọn ít nhất một hình ảnh' }]}
        extra="Hỗ trợ định dạng: JPG, PNG. Tối đa 5MB mỗi ảnh."
      >
        <Upload
          listType="picture-card"
          fileList={fileList}
          onChange={handleChange}
          beforeUpload={(file) => {
            const isImage = file.type.startsWith('image/');
            const isLt5M = file.size / 1024 / 1024 < 5;

            if (!isImage) {
              message.error('Chỉ cho phép upload file hình ảnh!');
              return false;
            }

            if (!isLt5M) {
              message.error('Kích thước hình ảnh phải nhỏ hơn 5MB!');
              return false;
            }

            return false;
          }}
          accept="image/*"
          multiple
        >
          <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Tải lên</div>
          </div>
        </Upload>
      </Form.Item>
    </div>
  );
};

const PostManagement: React.FC = () => {
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingPost, setEditingPost] = useState<Post | null>(null);
  const [form] = Form.useForm();
  const [imageFiles, setImageFiles] = useState<File[]>([]);
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [searchText, setSearchText] = useState('');
  const [statusFilter, setStatusFilter] = useState<string>('');
  const [lstPostZalo, setLstPostZalo] = useState<any[]>([]);
  const [detailModalVisible, setDetailModalVisible] = useState(false);
  const [selectedPostDetail, setSelectedPostDetail] = useState<any>(null);
  const isMobile = windowWidth <= 768;

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // fetchPosts();
    getPostZalo();
  }, []);

  useEffect(() => {
    console.log('lstPostZalo: ', lstPostZalo);
  }, [lstPostZalo]);

  const getPostZalo = async () => {
    setLoading(true);
    try {
      console.log('Starting Zalo sync...');
      const posts = await postService.syncZaloPosts();
      console.log('Zalo sync completed, posts:', posts);
      setLstPostZalo(posts);
      await fetchPosts();
    } catch (error) {
      console.error('Error fetching Zalo posts:', error);
      message.error('Không thể tải danh sách bài viết từ Zalo');
    } finally {
      setLoading(false);
    }
  };

  const fetchPosts = async () => {
    setLoading(true);
    try {
      console.log('Fetching all posts...');
      const data = await postService.getAllPosts();
      console.log('Fetched posts:', data);
      setPosts(data);
    } catch (error) {
      console.error('Error fetching posts:', error);
      message.error('Không thể tải danh sách bài viết');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (values: any) => {
    setSubmitLoading(true);
    try {
      console.log('values: ', values);
      console.log('imageFiles: ', imageFiles);

      if (editingPost) {
        if (editingPost.source === 'zalo' && editingPost.zaloId) {
          // Update Zalo post
          const imageFile = imageFiles.length > 0 ? imageFiles[0] : undefined;
          await postService.updateZaloPost(editingPost.zaloId, values, imageFile);
          message.success('Cập nhật bài viết thành công');
        } else {
          // Update normal post
          await postService.updatePost(editingPost.id!, values, imageFiles);
          message.success('Cập nhật bài viết thành công');
        }
      } else {
        // Create new post on Zalo
        const imageFile = imageFiles.length > 0 ? imageFiles[0] : undefined;
        await postService.createZaloPost(values, imageFile);
        message.success('Tạo bài viết thành công');
      }

      setModalVisible(false);
      form.resetFields();
      setImageFiles([]);
      setFileList([]);

      getPostZalo();

      // Load lại trang
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error('Error saving post:', error);
      message.error('Có lỗi xảy ra khi lưu bài viết');
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleDelete = async (id: string) => {
    Modal.confirm({
      title: 'Xác nhận xóa',
      content: 'Bạn có chắc chắn muốn xóa bài viết này không?',
      okText: 'Xóa',
      okType: 'danger',
      cancelText: 'Hủy',
      onOk: async () => {
        try {
          await postService.deletePost(id);
          message.success('Xóa bài viết thành công');
          fetchPosts();
        } catch (error) {
          console.error('Error deleting post:', error);
          message.error('Không thể xóa bài viết');
        }
      }
    });
  };

  const getPostDetail = async (zaloId: string) => {
    try {
      const newConfigZalo = await configService.getConfig();
      const response = await axios.get(
        `https://openapi.zalo.me/v2.0/article/getdetail`,
        {
          params: { id: zaloId },
          headers: {
            'access_token': newConfigZalo?.access_token_zalo
          }
        }
      );

      if (response.data.error === 0) {
        console.log('get post detail: ', response.data.data);

        setSelectedPostDetail(response.data.data);
        setDetailModalVisible(true);
      } else {
        message.error('Không thể tải chi tiết bài viết');
      }
    } catch (error) {
      console.error('Error fetching post detail:', error);
      message.error('Không thể tải chi tiết bài viết');
    }
  };

  const renderPostDetail = () => {
    if (!selectedPostDetail) return null;

    return (
      <div style={{ padding: '20px' }}>
        {selectedPostDetail.cover?.photo_url && (
          <div style={{ marginBottom: 20 }}>
            <img
              src={selectedPostDetail.cover.photo_url}
              alt={selectedPostDetail.title}
              style={{ maxWidth: '100%', borderRadius: 8 }}
            />
          </div>
        )}
        <h2>{selectedPostDetail.title}</h2>
        {selectedPostDetail.description && (
          <div style={{
            color: '#666',
            marginBottom: 20,
            padding: '10px',
            background: '#f5f5f5',
            borderRadius: 4
          }}>
            {selectedPostDetail.description}
          </div>
        )}
        <div>
          {selectedPostDetail.body?.map((item: any, index: number) => {
            if (item.type === 'text') {
              return (
                <div
                  key={index}
                  style={{ marginBottom: 16, whiteSpace: 'pre-wrap' }}
                  dangerouslySetInnerHTML={{ __html: item.content }}
                />
              );
            }
            return null;
          })}
        </div>
        <div style={{ marginTop: 20, borderTop: '1px solid #eee', paddingTop: 20 }}>
          <Space>
            <Tag color="blue">Trạng thái: {selectedPostDetail.status}</Tag>
            {selectedPostDetail.author && (
              <Tag color="green">Tác giả: {selectedPostDetail.author}</Tag>
            )}
            <Tag color={selectedPostDetail.comment === 'show' ? 'green' : 'orange'}>
              Bình luận: {selectedPostDetail.comment === 'show' ? 'Cho phép' : 'Ẩn'}
            </Tag>
          </Space>
        </div>
      </div>
    );
  };

  const columns = [
    {
      title: 'Hình ảnh',
      dataIndex: 'thumb',
      key: 'thumb',
      width: 120,
      render: (thumb: string, record: Post) => (
        <div style={{ width: 100, height: 100, overflow: 'hidden' }}>
          <img
            src={thumb || (record.imageUrls && record.imageUrls[0])}
            alt={record.title}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: '4px'
            }}
            onError={(e: any) => {
              e.target.onerror = null;
              e.target.src = 'https://placehold.co/100x100?text=No+Image';
            }}
          />
        </div>
      ),
    },
    {
      title: 'Tiêu đề',
      dataIndex: 'title',
      key: 'title',
      render: (title: string, record: Post) => (
        <div>
          <div style={{ fontWeight: 'bold', marginBottom: 4 }}>{title}</div>
          <div style={{ fontSize: '12px', color: '#666', marginBottom: 4 }}>{record.description}</div>
          {record.source === 'zalo' && (
            <div style={{ fontSize: '12px', color: '#666' }}>
              <span style={{ marginRight: 16 }}>
                <EyeOutlined /> {record.total_view || 0}
              </span>
              <span>
                <ShareAltOutlined /> {record.total_share || 0}
              </span>
            </div>
          )}
        </div>
      ),
    },
    {
      title: 'Nguồn',
      dataIndex: 'source',
      key: 'source',
      width: 100,
      render: (source: string) => (
        <Tag color={source === 'zalo' ? 'blue' : 'green'}>
          {source === 'zalo' ? 'Zalo' : 'Thủ công'}
        </Tag>
      ),
    },
    {
      title: 'Trạng thái',
      dataIndex: 'status',
      key: 'status',
      width: 120,
      render: (status: string) => (
        <Tag color={status === 'show' ? 'green' : 'orange'}>
          {status === 'show' ? 'Đã xuất bản' : 'Bản nháp'}
        </Tag>
      ),
    },
    {
      title: 'Ngày tạo',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 120,
      render: (date: any) => new Date(date.seconds * 1000).toLocaleDateString('vi-VN'),
    },
    {
      title: 'Ngày cập nhật',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      width: 120,
      render: (date: any) => new Date(date.seconds * 1000).toLocaleDateString('vi-VN'),
    },
    {
      title: 'Thao tác',
      key: 'action',
      width: 150,
      render: (_: any, record: Post) => (
        <Space>
          {record.source === 'zalo' && (
            <Button
              icon={<FileTextOutlined />}
              onClick={() => getPostDetail(record.zaloId!)}
              title="Xem chi tiết"
            />
          )}
          {record.link_view && (
            <Button
              icon={<LinkOutlined />}
              onClick={() => window.open(record.link_view, '_blank')}
              title="Xem trên Zalo"
            />
          )}
          <Button
            icon={<EditOutlined />}
            onClick={async () => {
              // Reset only image states before loading new post
              setFileList([]);
              setImageFiles([]);
              form.setFieldValue('images', undefined);

              if (record.source === 'zalo' && record.zaloId) {
                try {
                  const newConfigZalo = await configService.getConfig();
                  const response = await axios.get(
                    `https://openapi.zalo.me/v2.0/article/getdetail`,
                    {
                      params: { id: record.zaloId },
                      headers: {
                        'access_token': newConfigZalo?.access_token_zalo
                      }
                    }
                  );

                  console.log('detail post: ', response.data.data);

                  if (response.data.error === 0) {
                    const postDetail = response.data.data;
                    setEditingPost(record);
                    
                    // Set form values without resetting
                    form.setFieldsValue({
                      title: postDetail.title,
                      description: postDetail.description,
                      content: postDetail.body
                        ?.filter((item: any) => item.type === 'text')
                        ?.map((item: any) => {
                          if (item.content.includes('<') && item.content.includes('>')) {
                            return item.content;
                          }
                          return `<p>${item.content}</p>`;
                        })
                        ?.join('\n') || '',
                      author: postDetail.author,
                      images: postDetail.cover?.photo_url ? [postDetail.cover.photo_url] : []
                    });

                    // Set image if exists
                    if (postDetail.cover?.photo_url) {
                      const imageUrl = postDetail.cover.photo_url;

                      console.log('imageUrl: ', imageUrl);
                      const fileList = [{
                        uid: '-1',
                        name: 'image.png',
                        status: 'done' as const,
                        url: imageUrl,
                      }];
                      setFileList(fileList);

                      console.log('fileList: ', fileList);

                      // Convert URL to File object
                      try {
                        const response = await fetch(imageUrl);
                        const blob = await response.blob();
                        const file = new File([blob], 'image.png', { type: blob.type });
                        setImageFiles([file]);
                      } catch (error) {
                        console.error('Error converting URL to File:', error);
                      }
                    }
                    setModalVisible(true);
                  } else {
                    message.error('Không thể tải chi tiết bài viết');
                  }
                } catch (error) {
                  console.error('Error fetching post detail:', error);
                  message.error('Không thể tải chi tiết bài viết');
                }
              } else {
                // For non-Zalo posts
                setEditingPost(record);
                
                // Set form values without resetting
                form.setFieldsValue({
                  ...record,
                  images: record.imageUrls
                });

                if (record.imageUrls && record.imageUrls.length > 0) {
                  const fileList = record.imageUrls.map((url, index) => ({
                    uid: `-${index}`,
                    name: `image-${index}.png`,
                    status: 'done' as const,
                    url: url,
                  }));
                  setFileList(fileList);

                  // Convert URLs to File objects
                  try {
                    const files = await Promise.all(
                      record.imageUrls.map(async (url) => {
                        const response = await fetch(url);
                        const blob = await response.blob();
                        return new File([blob], 'image.png', { type: blob.type });
                      })
                    );
                    setImageFiles(files);
                  } catch (error) {
                    console.error('Error converting URLs to Files:', error);
                  }
                }
                setModalVisible(true);
              }
            }}
          />
          <Button
            icon={<DeleteOutlined />}
            danger
            onClick={() => handleDelete(record.id!)}
          />
        </Space>
      ),
    },
  ];

  const getFilteredPosts = () => {
    return posts.filter(post => {
      const matchesSearch = post.title.toLowerCase().includes(searchText.toLowerCase());
      const matchesStatus = !statusFilter || post.status === statusFilter;
      return matchesSearch && matchesStatus;
    });
  };

  return (
    <div style={{ padding: isMobile ? 12 : 24 }}>
      <div style={{
        marginBottom: 16,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: isMobile ? 'column' : 'row',
        gap: 16
      }}>
        <h1 style={{ margin: 0 }}>Quản lý bài viết</h1>

        <Space direction={isMobile ? 'vertical' : 'horizontal'} style={{ width: isMobile ? '100%' : 'auto' }}>
          <Search
            placeholder="Tìm kiếm bài viết"
            allowClear
            style={{ width: isMobile ? '100%' : 200 }}
            onChange={(e) => setSearchText(e.target.value)}
          />
          <Select
            placeholder="Lọc theo trạng thái"
            allowClear
            style={{ width: isMobile ? '100%' : 200 }}
            onChange={(value) => setStatusFilter(value)}
          >
            <Option value="draft">Bản nháp</Option>
            <Option value="published">Đã xuất bản</Option>
          </Select>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => {
              setEditingPost(null);
              form.resetFields();
              setImageFiles([]);
              setFileList([]);
              setModalVisible(true);
            }}
          >
            Thêm bài viết
          </Button>
        </Space>
      </div>

      <Table
        columns={columns}
        dataSource={getFilteredPosts()}
        loading={loading}
        rowKey="id"
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          showTotal: (total) => `Tổng số ${total} bài viết`,
        }}
      />

      <Modal
        title={editingPost ? "Sửa bài viết" : "Thêm bài viết mới"}
        visible={modalVisible}
        onCancel={() => {
          setModalVisible(false);
          setEditingPost(null);
          if (!editingPost) {
            // Only reset all fields when adding new post
            form.resetFields();
          } else {
            // Only reset image field when editing
            setFileList([]);
            setImageFiles([]);
            form.setFieldValue('images', undefined);
          }
        }}
        footer={null}
        width={800}
        // destroyOnClose={true}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          preserve={false}
        >
          <PostForm
            onImagesChange={setImageFiles}
            selectedFileList={fileList}
            isMobile={isMobile}
          />
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={submitLoading}>
              {editingPost ? 'Cập nhật' : 'Thêm mới'}
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Chi tiết bài viết"
        visible={detailModalVisible}
        onCancel={() => {
          setDetailModalVisible(false);
          setSelectedPostDetail(null);
        }}
        footer={null}
        width={800}
        // destroyOnClose={true}
      >
        {renderPostDetail()}
      </Modal>
    </div>
  );
};

export default PostManagement; 